import { render } from "./ContentTeaser.vue?vue&type=template&id=4d32eab7"
import script from "./ContentTeaser.vue?vue&type=script&lang=js"
export * from "./ContentTeaser.vue?vue&type=script&lang=js"

import "./ContentTeaser.vue?vue&type=style&index=0&id=4d32eab7&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__